/**
 * The year-grid header. The days-grid header is the `monthYear` display format instead, which
 * follows the company's default/US profile (`2026.09` / `Sep 2026`).
 */
export const YEAR_FORMAT = 'YYYY';

/**
 * Short month names for the month-picker grid. Explicit ids (like {@link WEEKDAYS}) rather than
 * moment's locale data, since the app never configures moment's locale — this keeps `hu` translatable.
 */
export const MONTHS_SHORT: readonly string[] = [
  $localize`:@@dp.jan:Jan`,
  $localize`:@@dp.feb:Feb`,
  $localize`:@@dp.mar:Mar`,
  $localize`:@@dp.apr:Apr`,
  $localize`:@@dp.may:May`,
  $localize`:@@dp.jun:Jun`,
  $localize`:@@dp.jul:Jul`,
  $localize`:@@dp.aug:Aug`,
  $localize`:@@dp.sep:Sep`,
  $localize`:@@dp.oct:Oct`,
  $localize`:@@dp.nov:Nov`,
  $localize`:@@dp.dec:Dec`,
];

/** Years shown per page in the year-picker grid — a 4-column, 6-row block. */
export const YEARS_PER_PAGE = 24;

/**
 * Weekday initials, Monday first. Explicit ids because a single letter is not a usable
 * translation key on its own — `hu` needs H/K/Sze/Cs/P/Szo/V.
 */
export const WEEKDAYS: readonly string[] = [
  $localize`:@@dp.mon:M`,
  $localize`:@@dp.tue:T`,
  $localize`:@@dp.wed:W`,
  $localize`:@@dp.thu:T`,
  $localize`:@@dp.fri:F`,
  $localize`:@@dp.sat:S`,
  $localize`:@@dp.sun:S`,
];

/** Rows the grid always renders, so stepping months never resizes the popup. */
export const WEEKS_SHOWN = 6;
export const DAYS_PER_WEEK = 7;
